import { Reveal } from "./Reveal";

export const SectionHeading = ({ number, eyebrow, title, description, align = "left" }) => (
  <Reveal className={`mb-12 sm:mb-16 ${align === "center" ? "text-center" : ""}`}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      {number && (
        <span className="font-display text-sm font-bold tracking-[0.3em] text-brand">{number}</span>
      )}
      <span className="h-px w-10 bg-brand/40" aria-hidden="true" />
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">{eyebrow}</span>
    </div>
    <h2 className="mt-5 font-display text-3xl font-bold leading-none tracking-tight text-brand-dark sm:text-4xl">
      {title}
    </h2>
    {description && (
      <p className={`mt-4 max-w-2xl text-base leading-relaxed text-slate-600 ${align === "center" ? "mx-auto" : ""}`}>
        {description}
      </p>
    )}
  </Reveal>
);
